/* eslint-disable class-methods-use-this, no-param-reassign */
import "./brands-video-player.scss";

class VideoPlayer {
  get #videoElements() {
    return document.querySelectorAll("video:not([autoplay])");
  }

  get #playButton() {
    const $button = document.createElement("button");
    $button.classList.add("brands-video-player__button", "brands-video-player__button--play");
    $button.innerHTML = this.#icon("play-circle");

    $button.addEventListener("click", () => this.#togglePlay($button));
    return $button;
  }

  get #muteButton() {
    const $button = document.createElement("button");
    $button.classList.add("brands-video-player__button", "brands-video-player__button--mute");
    $button.innerHTML = this.#icon("volume-off");

    $button.addEventListener("click", () => this.#toggleMute($button));
    return $button;
  }

  get #wrapper() {
    const $wrapper = document.createElement("div");
    $wrapper.classList.add("brands-video-player");

    $wrapper.appendChild(this.#playButton);
    $wrapper.appendChild(this.#muteButton);

    return $wrapper;
  }

  #attachEvents($video, $wrapper) {
    $video.addEventListener("play", e => {
      $wrapper.classList.add("brands-video-player--playing");
      this.#videoElements.forEach($videoElement => {
        if ($videoElement === e.target) return;
        $videoElement.pause();
      });
    });

    $video.addEventListener("pause", () => {
      $wrapper.classList.remove("brands-video-player--playing");
    });

    $video.addEventListener("click", () => {
      const $playButton = $wrapper.querySelector(".brands-video-player__button--play");
      this.#togglePlay($playButton);
    });
  }

  #icon(name) {
    return `
      <svg class="icon icon--svg icon--${name} brands-video-player__icon brands-video-player__icon--${name}">
        <use xlink:href="${window.jiffy.brands.svg_path}#svg_${name}"></use>
      </svg>
    `;
  }

  #togglePlay($button) {
    const $wrapper = $button.parentNode;
    const $video = $wrapper.querySelector("video");

    if ($video.paused) {
      $video.play();
    } else {
      $video.pause();
    }

    $button.innerHTML = this.#icon($video.paused ? "play-circle" : "pause-circle");
  }

  #toggleMute($button) {
    const $wrapper = $button.parentNode;
    const $video = $wrapper.querySelector("video");

    $video.muted = !$video.muted;
    $button.innerHTML = this.#icon($video.muted ? "volume-on" : "volume-off");
  }

  init() {
    const $videoElements = this.#videoElements;
    $videoElements.forEach($video => {
      const $wrapper = this.#wrapper;
      const $clonedVideo = $video.cloneNode(true);

      this.#attachEvents($clonedVideo, $wrapper);
      $wrapper.appendChild($clonedVideo);
      $video.parentNode.replaceChild($wrapper, $video);
    });
  }
}

export default () => {
  const videoPlayer = new VideoPlayer();
  videoPlayer.init();
};
